import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SignalAntennaIcon } from "@ui/components/icons/SidebarIcons";
import { DesignTooltip } from "@ui/components/tooltip/DesignTooltip";
export const FreeRoamingBadge = ({ size = "small", iconOnly = true, }) => {
    const { t } = useTranslation(["common"]);
    const icon = (React.createElement(Box, { sx: { display: "flex" } },
        React.createElement(SignalAntennaIcon, { size: 14 })));
    return (React.createElement(DesignTooltip, { maxWidth: 171, title: React.createElement(Box, null,
            React.createElement(Typography, { component: "div", sx: { fontSize: 14, lineHeight: "22px", fontWeight: 600 } },
                t("common:grid.freeRoaming"),
                ":"),
            t("common:descriptions.freeRoamingNodeBadge")) }, iconOnly ? (React.createElement(Chip, { icon: icon, size: size, variant: "soft", color: "info", "aria-label": t("common:grid.freeRoaming"), sx: {
            "& .MuiChip-label": { display: "none" },
            width: 28,
            "& .MuiChip-icon": { margin: 0 },
        } })) : (React.createElement(Chip, { icon: icon, label: t("common:grid.freeRoaming"), size: size, variant: "soft", color: "info" }))));
};
export default FreeRoamingBadge;
